module.exports = __webpack_public_path__ + "images/feature/popup-sxh-890b8e81747212cb17c94808521bbd3b.png";